import SolutionCard from "../../reusables/SolutionCard";
import consult from "../../../assets/images/solutions-icon/it_consult.svg";

const ICTTrainingSolution = () => {
  return (
    <SolutionCard
      icon={consult}
      title="ICT Training & Capacity Building"
      subtitle="Build practical ICT & AI skills for life at the Uganda School of ICT"
      ctaLink="/solutions/ict-training"
    />
  ); 
};

export default ICTTrainingSolution;
